import mapboxgl, { GeoJSONSource } from "mapbox-gl";
import { addAllLayersInOrder, breaksPositionLyr } from "./layers";
import { initSources, breaksSources } from "./sources";
import { loadIcons } from "../../map/icons";
import { makeMap } from "../../map/map";
import { BreakReportsRow } from "../../../api/models/BreakReportsRow";
import { convertUTCtoJST } from "../../../utils/formatting";
import { point, CoordinateObject } from "../../map/convert/geojson";
import * as uuid from "uuid";

const hoveredItem: any = null;

export const initMap = async (
    mapContainerName: string
): Promise<mapboxgl.Map> => {
    const map = makeMap(mapContainerName);

    await map.on("load", async () => {
        await initSources(map);
        await loadIcons(map);
        await addAllLayersInOrder(map);
    });

    map.on("mouseover", () => {
        map.getCanvas().style.cursor = "initial";
    });
    map.on("mouseleave", () => {
        map.getCanvas().style.cursor = "";
    });

    setHighlightWithPopup(
        breaksPositionLyr.id,
        breaksSources.breaksSrc,
        map,
        hoveredItem,
        breaksTemplate
    );

    return map;
};

export const convert = (reports: BreakReportsRow[]): any => {
    const _p = reports.map((x: BreakReportsRow) => {
        return {
            ...x,
            coordinates: [x.breakLocLng, x.breakLocLat],
            id: uuid.v4(),
        };
    });
    const points = point(_p as CoordinateObject[]);
    return { points };
};

export const show = async (
    map: mapboxgl.Map,
    report?: any | null
): Promise<void> => {
    if (!report) {
        return;
    }

    const { points } = convert(report);

    if (map.loaded()) {
        (map.getSource(breaksSources.breaksSrc) as GeoJSONSource).setData(
            points
        );
    } else {
        map.on("load", async () => {
            console.debug("Breaks map loaded.", points);
            (map.getSource(breaksSources.breaksSrc) as GeoJSONSource).setData(
                points
            );
        });
    }
};

export const setHighlightWithPopup = (
    layerName: string,
    dataSourceName: string,
    map: mapboxgl.Map,
    hoveredItem: any,
    templateMaker: any
): void => {
    let popup;
    map.on("mouseenter", layerName, (e: any) => {
        map.getCanvas().style.cursor = "pointer";
        hoveredItem = e.features[0].id;

        if (hoveredItem) {
            map.setFeatureState(
                { source: dataSourceName, id: hoveredItem },
                { hover: false }
            );

            if (e.features && e.features[0] && e.features[0].properties) {
                popup = new mapboxgl.Popup()
                    .setLngLat(e.lngLat)
                    .setHTML(templateMaker(e.features[0]));
                popup.addTo(map);
            }
        }

        hoveredItem = e.features[0].id;

        (map as mapboxgl.Map).setFeatureState(
            { source: dataSourceName, id: hoveredItem },
            { hover: true }
        );
    });

    map.on("mouseleave", layerName, (e: any) => {
        if (hoveredItem) {
            map.setFeatureState(
                { source: dataSourceName, id: hoveredItem },
                { hover: false }
            );
        }
        map.getCanvas().style.cursor = "initial";
        hoveredItem = null;
        popup.remove();
    });
};

export const breaksTemplate = (feature: any) => {
    return `
                    <div>
                    <strong>
                    休憩位置
                    </strong>
                    </div>
                    <div>
                    休憩場所: ${feature.properties.breakCityName}
                    </div>
                    <div>
                    休憩開始時刻: ${convertUTCtoJST(
                        feature.properties.breakStartTs
                    )}
                    </div>
                    `;
};
